// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2u69N","col":"styles_col__3j4b-","fulfillmentStatus":"styles_fulfillmentStatus__40iQs","emailCol":"styles_emailCol__2hv7_"};